import './overlay.block.scss';

// the parent element must have position relative if using this component
const OverlayBlock = () => <div className="overlay-block" />;

OverlayBlock.displayName = 'OverlayBlock';
export default OverlayBlock;
